import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { BaseFilterProps, CmsUsersResponse } from "@/shared/utils/interfaces";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

interface Props extends BaseFilterProps {}

const useCmsAccountsQuery = (
  enabled = false,
  { pageNumber = 1, pageSize = 10, filters = {} }: Props,
  customBranch?: number
) => {
  const br = useBranchId();
  const branch = customBranch || br;

  const query = useQuery<CmsUsersResponse[]>({
    queryKey: ["cms/users", branch, pageNumber, pageSize, JSON.stringify(filters)],
    queryFn: () =>
      get2(`internal/secure/pos/v1/cms/account/${branch}`, {
        params: {
          ...filters,
          pageSize,
          pageNumber
        }
      }),
    placeholderData: keepPreviousData,
    enabled,
    staleTime: Infinity
  });

  return { query };
};

export default useCmsAccountsQuery;
